import { render, staticRenderFns } from "./ergo-accessories-a45.vue?vue&type=template&id=687f967a"
import script from "./ergo-accessories-a45.vue?vue&type=script&lang=js"
export * from "./ergo-accessories-a45.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports